import Routes from './Routes'

function Main() {
	return (
		<main className='main'>
			<Routes />
		</main>
	)
}

export default Main
